import { Flex } from '@teamsparta/stack-flex';
import Image from 'next/image';

import Only from '@/components/common/Only';

import * as S from './style';

export function Hero() {
  return (
    <S.Wrapper>
      <S.HeroContentWrapper>
        <Flex.Column align='center' gap='2px'>
          <Image
            src='/images/campaign/campaign_hh_logo.png'
            width={43}
            height={13}
            alt='logo'
            loading='eager'
            priority
            style={{
              objectFit: 'contain',
            }}
          />
          <S.HeroLogoTitle>개발자 잔디 기부 캠페인</S.HeroLogoTitle>
        </Flex.Column>
        <Only.Mobile>
          <Flex.Column align='center' gap='10px'>
            <Image
              src='/images/campaign/campaign_contribute_word.png'
              width={259}
              height={76}
              alt='campaign_word'
              loading='eager'
              priority
              style={{
                objectFit: 'contain',
              }}
            />
            <S.Title>세상의 성장에 기여하세요</S.Title>
          </Flex.Column>
        </Only.Mobile>
        <Only.Desktop>
          <Flex.Column align='center' gap='12px'>
            <Image
              src='/images/campaign/campaign_contribute_word.png'
              width={272}
              height={90}
              alt='campaign_word'
              loading='eager'
              priority
              style={{
                objectFit: 'contain',
              }}
            />
            <S.Title>세상의 성장에 기여하세요</S.Title>
          </Flex.Column>
        </Only.Desktop>
        <S.Period>12/16(월) ~ 12/31(화)</S.Period>
      </S.HeroContentWrapper>
      <Only.Mobile>
        <S.ImageWrapper>
          <Image
            src='/images/campaign/campaign_hero_tree_tablet.png'
            fill
            alt='campaign_hero_tree'
            priority
            loading='eager'
            sizes='100dvw'
          />
        </S.ImageWrapper>
      </Only.Mobile>
      <Only.Desktop>
        <S.DesktopImageWrapper>
          <Image
            src='/images/campaign/campaign_hero_tree_desktop.png'
            fill
            alt='campaign_hero_tree'
            priority
            loading='eager'
            sizes='100dvw'
          />
        </S.DesktopImageWrapper>
      </Only.Desktop>
    </S.Wrapper>
  );
}
